export function useUseChangeWorksheetStatus() {
  const worksheetOverviewStore = useWorksheetOverviewStore();
  const worksheetDetailsStore = useWorksheetDetailsStore();
  const userConfigurationStore = useUserConfigurationStore();
  const worksheetAPI = useWorksheetAPI();

  async function setWorksheetAsActive(worksheetID: number | undefined, fitterID: number| undefined, status?: string) {
    if (!userConfigurationStore._userConfiguration || !worksheetID) {
      return;
    }

    if (fitterID !== userConfigurationStore._userConfiguration.FitterID) {
      return;
    }
    
    if (worksheetID !== worksheetDetailsStore._worksheetById?.WorksheetID) {
      await worksheetDetailsStore.getWorksheetById(worksheetID);
    }

    if (worksheetDetailsStore._worksheetById?.StatusEnum !== WorksheetStatus.NotStarted || (status !== 'NotStarted' && status !== undefined) ) {
      return;
    }

    const response = await worksheetAPI.changeStatus({
      WorksheetID: worksheetID,
      FitterID: fitterID,
      FitterNote: '',
      SecondaryStatuses: worksheetDetailsStore._secondaryStatuses.SecondaryStatuses,
      WorksheetStatus: WorksheetStatus.InProgress
    });
  
    if (response && !response.HasErrors && response.Data.Success === true) {
      worksheetDetailsStore.updateStatus({
        primaryStatus: WorksheetStatus.InProgress,
        secondaryStatuses: worksheetDetailsStore._secondaryStatuses.SecondaryStatuses,
        fitterNote: ''
      });
      worksheetOverviewStore.updateWorksheetStatus(worksheetID, WorksheetStatus.InProgress);
    }
  }

  return {
    setWorksheetAsActive
  };
}
